// In packages/components and not constants.ts in intercept strategy bc editQuiz cannot import intercept strategy bc of circular dependency

import type { LmsSetupGuideStep } from "@yujacorp/verity-api-contract";

//  In separate file so service worker can import without getting window undefined error
export const SETUP_GUIDE_ATTRIBUTES = {
	CLASSNAME: {
		HIGHLIGHT: "verity-setup-guide-highlight",
	},
	ID: {
		WRAPPER: "verity-setup-guide-wrapper",

		EDIT_QUIZ_IFRAME: "verity-setup-proctoring-iframe",
		EDIT_QUIZ_IFRAME_ROOT: "verity-iframe-modal-root",
		SCROLLBAR_STYLE: "verity-scrollbar-style-id",
	},
	KEY: {
		GUIDE: "verity-setup-guide-shadow",
		PROMPT: "verity-highlight-prompt-shadow",
	},
	Z_INDEX: {
		GUIDE_WRAPPER: 99999999,
		GUIDE: 1400, // Above mui modal/drawer (1300), smaller than mui tooltip (1500)
		HIGHLIGHT: 10001, // bb original's popover z-index is 10000
		// Smaller than guide
		HIGHLIGHT_PORTAL: 99,
		EDIT_QUIZ: 9997,
	},
	MESSAGE: {
		TYPE: {
			CLEANUP: "VERITY_CLEANUP_SETUP_GUIDE",
			// Tells setup guide widget to re-fetch the active step and re-render,
			// Needed for LMS's who uses SPA-style routing rather than a real page load
			REFRESH: "VERITY_REFRESH_SETUP_GUIDE",
		},
	},
};

const PORTAL_INTEGRATION_TYPES = [
	"LTI 1.3",
	"LMS Visualizer",
	"LMS API",
	"Create Profile",
	"Browser Extension",
] as const;

type PortalIntegrationType = (typeof PORTAL_INTEGRATION_TYPES)[number];

export const INTEGRATION_TYPES: IntegrationType[] = [
	"LTI 1.3",
	"LMS API",
	"LMS Visualizer",
	"Create Profile",
	"Browser Extension",
	"Create Assessment",
	"Take Assessment",
	"View Results",
];

export type IntegrationType = PortalIntegrationType | Exclude<LmsSetupGuideStep, "Complete" | "None">;
